import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PURPLE_ARROW from './purple-arrow.svg'
import cx from 'classnames'
import BOT_AVATAR from './bot-avatar.svg'
import './style.css'

const TOP_OFFSET_IN_PX = 130
const DEFAULT_QUESTION_HEIGHT_IN_PX = 80

const ChatWindowRectangle = ({ className }) => (
  <div className={cx(className, "chat-window-rectangle")}></div>
)

const BotQuestion = ({ productName, valueProp }) => (
  <div className="bot-preview-question-wrapper">
    <img src={BOT_AVATAR} alt="bot-avatar"/>
    <div className="bot-preview-question">
      <div className="bot-preview-question--label">Bot</div>
      <div className="bot-preview-question--text">
        {`Do you want to see how ${productName} can help you ${valueProp}?`}
      </div>
    </div>
  </div>
)

export const TipPosition = Object.freeze({
  QUESTION: 0,
  RESPONSE: 1
})

class BotPreview extends Component {

  static propTypes = {
    productName: PropTypes.string.isRequired,
    valueProp: PropTypes.string,
    industry: PropTypes.string,
    buttonList: PropTypes.array
  }

  constructor(props) {
    super(props)
    this.state = {
      questionHeight: DEFAULT_QUESTION_HEIGHT_IN_PX
    }
  }

  renderBotButtons = (buttonText, index) => {
    return(
      <div className="bot-preview-answer" key={index}>
        {buttonText}
      </div>
    )
  }

  getButtonList = (productName, industry) => {
    return [`I’m researching ${industry}`, `I heard about ${productName} and I’m interested in learning more`]
  }

  componentDidMount() {
    this.setState({
      questionHeight: document.getElementsByClassName("bot-preview-question")[0].clientHeight
    })
  }

  render() {
    const { productName, valueProp, industry, tipText="Here’s what visitors will see", tipPosition=TipPosition.QUESTION, arrowSrc=PURPLE_ARROW } = this.props
    const { questionHeight } = this.state
    const buttonList = this.getButtonList(productName, industry)
    const buttonMarginTop = (TOP_OFFSET_IN_PX + questionHeight).toString() +"px"
    return(
      <div className="bot-preview-wrapper">
        <div className="chat-window-wrapper">
          <div className="chat-window-top-section">
            <ChatWindowRectangle className="chat-window-rectangle--top" />
            <BotQuestion productName={productName} valueProp={valueProp}/>
            {!!industry && <div className="bot-preview-answer-wrapper"> {buttonList.map(this.renderBotButtons)}</div>}
          </div>
          <div className="chat-window-bottom-section">
            <ChatWindowRectangle className="chat-window-rectangle--bottom-full" />
            <div className="chat-window-bottom-row"> <ChatWindowRectangle className="chat-window-rectangle--bottom-left" />
              <ChatWindowRectangle className="chat-window-rectangle--bottom-right" /></div>
          </div>
        </div>
        {tipPosition === TipPosition.QUESTION ? <div className="bot-preview-tip"><img src={arrowSrc} alt="purple-arrow"/>{tipText}</div>
        : <div className="bot-preview-tip" style={{marginTop: `${buttonMarginTop}`}}><img src={arrowSrc} alt="purple-arrow"/>{tipText}</div>}
      </div>
    )
  }
}

export default BotPreview


// WEBPACK FOOTER //
// ./src/components/OnboardingBotPreview/index.js